module.exports = __webpack_public_path__ + "img/full5-min.9a7e3101.png";